// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Documents_mainContainer__hX8TM"};